<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="loading">
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<div *ngIf="!loading && business" class="main-wrapper py-4 px-3">
  <!-- Profile Header Card (Mock 4 layout) -->
  <div class="row m-0 mb-4">
    <div class="col-12 p-0">
      <div class="profile-hero-container position-relative">
        <!-- Cover Photo -->
        <div class="profile-cover-img" [ngStyle]="{'background-image': 'url(' + ((business.Logo ? business.Logo : business.ProfilePicture).source || 'assets/about.jpg') + ')'}"></div>
        <div class="profile-cover-gradient"></div>

        <!-- Float Buttons on Cover -->
        <button (click)="back()" class="hero-float-btn back-btn" mat-mini-fab aria-label="Go Back">
          <mat-icon>arrow_back</mat-icon>
        </button>
        
        <div class="hero-float-right-buttons">
          <button class="hero-float-btn fav-btn" [ngClass]="{'active': isFavorite}" mat-mini-fab [attr.aria-label]="isFavorite ? 'Remove from favourites' : 'Add to favourites'" [disabled]="updatingFavorite" (click)="isFavorite ? unFavouriteBusiness(business.id) : favouriteBusiness(business)">
            <mat-icon>{{ isFavorite ? 'favorite' : 'favorite_border' }}</mat-icon>
          </button>
          <button class="hero-float-btn share-btn" mat-mini-fab aria-label="Share business" [matMenuTriggerFor]="businessShareMenu">
            <mat-icon>share</mat-icon>
          </button>
          <mat-menu #businessShareMenu="matMenu">
            <button mat-menu-item (click)="copyLink()">
              <mat-icon>link</mat-icon>
              <span>Copy Link</span>
            </button>
            <button mat-menu-item (click)="shareViaWhatsApp()">
              <mat-icon>share</mat-icon>
              <span>Share via WhatsApp</span>
            </button>
          </mat-menu>
        </div>

        <!-- Overlapping Profile Avatar Logo -->
        <div class="profile-avatar-circle bg-white text-white font-weight-bold d-flex align-items-center justify-content-center">
          <img *ngIf="(business.Logo || business.ProfilePicture)?.source" [src]="(business.Logo ? business.Logo : business.ProfilePicture).source" alt="Avatar" class="img-fluid rounded-circle" />
          <span *ngIf="!(business.Logo || business.ProfilePicture)?.source">{{business.Name.substring(0, 2).toUpperCase()}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Business Headline details -->
  <div class="row m-0 justify-content-between align-items-start pt-3 pb-3 mb-3 border-bottom flex-wrap gap-3">
    <div class="flex-1 min-w-300">
      <h1 class="font-weight-bold text-dark mb-1 text-2xl">{{business.Name}}</h1>
      <p class="text-muted mb-2 text-sm d-flex align-items-center"><mat-icon class="text-sm mr-1">place</mat-icon>{{business.Address}}</p>
      
      <!-- Ratings / Status badge -->
      <div class="d-flex align-items-center flex-wrap gap-2 text-sm">
        <div class="d-flex align-items-center text-warning mr-2" *ngIf="reviews.length > 0" (click)="viewReviews()" class="link">
          <fa-icon [icon]="faStar" class="mr-1"></fa-icon>
          <span class="font-weight-bold text-dark mr-1">{{averageRating}}</span>
          <span class="text-muted">({{reviews.length}} Reviews)</span>
        </div>
        <div class="d-flex align-items-center text-warning mr-2" *ngIf="reviews.length === 0">
          <fa-icon [icon]="faStar" class="text-muted mr-1"></fa-icon>
          <span class="text-muted">No Reviews</span>
        </div>

        
        <!-- Status indicator hours -->
        <div class="d-flex align-items-center ml-1" *ngIf="business.TradingHours && business.TradingHours.length > 0">
          <ng-container *ngFor="let day of business.TradingHours">
            <div *ngIf="day.startTime && day.open && day.day === today" class="d-flex align-items-center">
              <span class="status-indicator-dot mr-2" [ngClass]="compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'bg-success' : 'bg-danger'"></span>
              <span class="font-weight-bold mr-1" [ngClass]="compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'text-success' : 'text-danger'">
                {{compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'Open Now' : 'Closed'}}
              </span>
              <span class="text-muted">{{ day.startTime }} - {{ day.endTime }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Stats Row (Less Prominent) -->
      <div class="d-flex align-items-center gap-3 text-muted text-xs mt-2 flex-wrap">
        <span class="d-flex align-items-center"><mat-icon class="text-sm align-middle mr-1">visibility</mat-icon> Views</span>
        <span class="text-muted-50">|</span>
        <span class="d-flex align-items-center"><mat-icon class="text-sm align-middle mr-1">group</mat-icon> Followers</span>
        <span class="text-muted-50">|</span>
        <!-- <span class="d-flex align-items-center"><mat-icon class="text-sm align-middle mr-1">insights</mat-icon> 274 Leads Generated</span> -->
      </div>
    </div>

    <!-- Quick Action Booking button -->
    <div class="d-flex gap-2">
      <button color="primary" class="rounded-pill px-4 py-2 font-weight-bold text-white bg-primary" mat-flat-button (click)="createAppointment(business)">
        <mat-icon class="mr-1">calendar_month</mat-icon> Book Appointment
      </button>
    </div>
  </div>

  <!-- Row of Modern Quick Link Buttons -->
  <div class="row m-0 mb-4 gap-2 flex-wrap">
    <a [href]="'tel:' + business.Mobile" class="quick-action-btn-link flex-1" mat-stroked-button>
      <mat-icon class="mr-1 text-primary">phone</mat-icon> Call
    </a>
    <a [href]="'https://www.google.com/maps/search/?api=1&query=' + business.Address" target="_blank" class="quick-action-btn-link flex-1" mat-stroked-button>
      <mat-icon class="mr-1 text-primary">directions</mat-icon> Directions
    </a>
    <a *ngIf="business.Website" [href]="business.Website" target="_blank" class="quick-action-btn-link flex-1" mat-stroked-button>
      <fa-icon [icon]="faGlobe" class="mr-1 text-primary"></fa-icon> Website
    </a>
    <a *ngIf="business.Email" [href]="'mailto:' + business.Email" class="quick-action-btn-link flex-1" mat-stroked-button>
      <fa-icon [icon]="faEnvelope" class="mr-1 text-primary"></fa-icon> Email
    </a>
    <button (click)="chatOnWhatsApp(business.Mobile)" class="quick-action-btn-link flex-1 bg-whatsapp text-white" mat-flat-button>
      <img width="18px" src="assets/vecteezy_whatsapp-png-icon_16716468.png" class="mr-1"/> WhatsApp
    </button>
  </div>

  <!-- Business Main Overview details (Put back prominently) -->
  <div class="row m-0 mb-4 pt-2">
    <!-- Business Information Card -->
    <div class="col-md-6 mb-4 p-2">
      <div class="modern-card p-4 h-100 d-flex flex-column justify-content-start">
        <h2 class="font-weight-bold mb-3 text-dark text-lg">Business Information</h2>
        <p class="text-muted line-height-relaxed">{{business.About || 'No details provided.'}}</p>
        <div class="business-contact-details mt-3 pt-3 border-top">
          <a
            *ngIf="business.Website"
            [href]="business.Website"
            target="_blank"
            class="d-flex align-items-center text-muted text-sm mb-2"
          >
            <fa-icon [icon]="faGlobe" class="mr-2 text-primary"></fa-icon>
            <span>{{ business.Website }}</span>
          </a>
          <a
            *ngIf="business.Email"
            [href]="'mailto:' + business.Email"
            class="d-flex align-items-center text-muted text-sm mb-2"
          >
            <fa-icon [icon]="faEnvelope" class="mr-2 text-primary"></fa-icon>
            <span>{{ business.Email }}</span>
          </a>
          <a
            *ngIf="business.Mobile"
            [href]="'tel:' + business.Mobile"
            class="d-flex align-items-center text-muted text-sm"
          >
            <mat-icon class="text-sm mr-2 text-primary">phone</mat-icon>
            <span>{{ business.Mobile }}</span>
          </a>
        </div>
        <a *ngIf="business.Website" [href]="business.Website" target="_blank" class="mt-auto pt-3 text-primary font-weight-bold">
          Visit Website <mat-icon class="text-xs">arrow_forward</mat-icon>
        </a>
      </div>
    </div>

    <!-- Trading Hours Card -->
    <div class="col-md-6 mb-4 p-2">
      <div class="modern-card p-4 h-100">
        <h2 class="font-weight-bold mb-3 text-dark text-lg">Trading Hours</h2>
        <div class="w-100" *ngIf="business.TradingHours && business.TradingHours.length > 0">
          <div *ngFor="let day of business.TradingHours" class="d-flex justify-content-between py-2 border-bottom text-sm" [ngClass]="{'bg-light font-weight-bold p-2 rounded': day.day === today}">
            <span class="text-dark">{{ day.day }}</span>
            <span class="text-muted" *ngIf="day.open">{{ day.startTime }} - {{ day.endTime }}</span>
            <span class="text-danger font-weight-bold" *ngIf="!day.open">Closed</span>
          </div>
        </div>
        <div *ngIf="!business.TradingHours || business.TradingHours.length < 1" class="text-muted">
          Hours are not specified.
        </div>
      </div>
    </div>

    <!-- Location Card -->
    <div class="col-12 mb-4 p-2">
      <div class="modern-card p-4">
        <h2 class="font-weight-bold mb-3 text-dark text-lg">Location Map</h2>
        <div class="d-flex align-items-center mb-3">
          <mat-icon class="text-primary mr-2">place</mat-icon>
          <span class="text-dark font-weight-bold">{{business.Address}}</span>
        </div>
        
        <app-map [loggedIn]="loggedIn" style="min-width: 100%;" class="mt-2" *ngIf="business.Address" [location]="business.Address"></app-map>
        
        <div *ngIf="!loggedIn" class="mt-3 p-3 bg-light rounded text-center">
          <p class="text-muted m-0">Register or login to see full map directions.</p>
          <button mat-flat-button color="primary" routerLink="/auth" class="mt-2 rounded-pill text-white bg-primary">
            Login / Register
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Secondary Actions Tab Group -->
  <mat-tab-group #tabs class="modern-tabs">
    <!-- Reviews Tab -->
    <mat-tab label="Customer Reviews">
      <div class="pt-4">
        <div class="modern-card p-4 mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div class="d-flex align-items-center" *ngIf="reviews.length > 0">
            <span class="font-weight-bold text-dark mat-display-1 m-0 mr-3">{{averageRating}}</span>
            <div class="d-flex flex-column">
              <app-star-rating [disabled]="true" [rating]="averageRating" [starCount]="5" [color]="starColor"></app-star-rating>
              <span class="text-muted text-xs">Based on {{reviews.length}} reviews</span>
            </div>
          </div>
          <div *ngIf="reviews.length === 0" class="text-muted font-weight-bold">
            No reviews yet. Be the first to review!
          </div>

          <button *ngIf="loggedIn" color="primary" mat-flat-button class="rounded-pill text-white bg-primary" (click)="createReview(business.id)">
            Write Review
          </button>
          <button *ngIf="!loggedIn" color="accent" mat-stroked-button class="rounded-pill" (click)="signUp()">
            Sign Up to Review
          </button>
        </div>

        <div class="row m-0">
          <div class="col-12 p-0 mb-3" *ngFor="let review of reviews">
            <div class="modern-card p-4">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div>
                  <h3 class="font-weight-bold text-dark m-0 text-md">{{review.Title}}</h3>
                  <div class="d-flex align-items-center mt-1">
                    <app-star-rating [disabled]="true" [rating]="review.Rating" [starCount]="5" [color]="starColor"></app-star-rating>
                    <span class="text-muted text-xs ml-2">({{review.Rating}}/5)</span>
                  </div>
                </div>
                <span class="text-muted text-xs">{{review.Date | date: 'dd MMM yyyy'}}</span>
              </div>
              <p class="text-muted m-0 mt-2 text-sm">{{review.Comment}}</p>
              <span class="text-dark font-weight-bold mt-3 d-inline-block text-xs">— {{review.User}}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Chat Tab -->
    <mat-tab label="Chat Box">
      <div class="pt-4">
        <div *ngIf="loggedIn" class="modern-card p-4">
          <h2 class="font-weight-bold text-dark text-lg mb-3">Engage with {{business.Name}}</h2>
          <app-conversation class="w-100" *ngIf="business" [recipient]="business"></app-conversation>
        </div>
        <div *ngIf="!loggedIn" class="modern-card p-5 text-center">
          <mat-icon class="text-muted display-4 mb-3">forum</mat-icon>
          <h3 class="font-weight-bold text-dark mb-3">Register for free and start chatting</h3>
          <p class="text-muted mb-4">Access active instant messaging to speak directly with service providers.</p>
          <button mat-flat-button color="primary" (click)="signUp()" class="rounded-pill px-4 py-2 text-white bg-primary">
            Register / Login
          </button>
        </div>
      </div>
    </mat-tab>

    <!-- Offers/Ads Tab -->
    <mat-tab label="Offers & Ads">
      <div class="row m-0 pt-4">
        <div class="col-md-4 mb-4" *ngFor="let ad of ads; let i = index">
          <div class="modern-card overflow-hidden h-100 d-flex flex-column justify-content-between">
            <app-ad [title]="ad.title" [body]="ad.body" [image1]="ad.image1"></app-ad>
            <div class="p-3 bg-light">
              <p class="text-muted m-0 text-xs">{{ad.body}}</p>
            </div>
          </div>
        </div>
        <div class="col-12 text-center py-5" *ngIf="!ads || ads.length < 1">
          <h3 class="text-muted">No active ads or promotional listings for this business.</h3>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
